module.exports = __webpack_public_path__ + "img/Suv_Front.37831d1b.svg";